import { render, staticRenderFns } from "./WV-SL-Disclosure.vue?vue&type=template&id=e9888780&scoped=true&"
import script from "./WV-SL-Disclosure.vue?vue&type=script&lang=js&"
export * from "./WV-SL-Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./WV-SL-Disclosure.vue?vue&type=style&index=0&id=e9888780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9888780",
  null
  
)

export default component.exports